import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/pc/rhRentInfo/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/pc/rhRentInfo/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/pc/rhRentInfo/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/pc/rhRentInfo/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/pc/rhRentInfo/delete/batch', {
    params: {
      ids
    }
  })
}
